<template>
  <div class="article-container">
    <BannerSearch> </BannerSearch>
    <div class="article">
      <div class="article-box">

        <SideTap class="win " :family="`'Nunito-Bold','HYZhengYuan-65W'`" :topAlert="$t('m.feature.title')" :size="16"
          :titleSize="20" :keys="tags" :pad="8" :lheight="28" :padding="15" :radius="'18px'" :marginBottom="40"
          :width="'310px'" :notActive="true">
        </SideTap>
        <!-- <SideTap class="pad" :keys="tags" :min="'auto'" :size="16" :padding="70" :family="'MohrRounded'"></SideTap> -->
        <div class="article-innerbox" style="width: 100%;">
          <el-skeleton style="width: 100%" :loading="loading" animated>
            <div class="title-box" style=" border-bottom: 2px solid rgba(0, 0, 0, 0.06);
      padding-bottom: 30px;
      margin-bottom: 27px;">
              <div class="title" v-if="article != ''" v-html="article.title.rendered"></div>
              <div class="user">{{ $t('m.article.office') }}</div>
              <div class="date">{{ convertedTime(article.modified) }}</div>
            </div>
            <template slot="template">
              <el-skeleton-item variant="text" style="width: 100%;margin:10px 0;    height: 35px;
                width: 62%;" />
              <el-skeleton-item variant="text" style="width: 20%;margin:10px 0;    display: block;" />
            </template>

          </el-skeleton>
          <div class="container">
            <el-skeleton style="width: 100%" :loading="loading" animated>
              <template slot="template">
                <el-skeleton-item variant="text" style="width: 100%;margin:10px 0;" v-for="index in 10" :key="index" />
                <el-skeleton-item variant="text" style="width: 62%;margin:10px 0;" />
              </template>
              <p class="p1" v-html="content">

              </p>
            </el-skeleton>
          </div>
          <Appraise></Appraise>
        </div>
      </div>

    </div>
    <!-- <Featured></Featured> -->
  </div>
</template>

<script>
import Appraise from "../components/Appraise.vue";
import Featured from "../components/Featured.vue";
import SideTap from "../components/SideTap.vue";
import BannerSearch from "../components/BannerSearch.vue";
import moment from 'moment-timezone';
// import i18n from "../lang";
export default {

  components: { Featured, SideTap, Appraise, BannerSearch },
  data() {
    return {
      tags: [],
      content: '',
      loading: true,
      article: '',
      userTimeZone: "",
    };
  },

  mounted() {
    this.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    console.log(this.userTimeZone);
    this.getDate()
    if (this.$store.state.InformationTwo != "") {
      this.$store.state.InformationOne.posts.map((item) => {

        this.tags.push(item.title);
      });
      
    }
  },
  methods: {
    decodeHTMLEntities(input) {
      const entities = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
        // 可根据需要添加其他转义字符和对应的替换值
      };

      return input.replace(/&amp;|&lt;|&gt;|&quot;|&#39;/g, match => entities[match]);
    },
    clickArt(v) {
      console.log(this.$route);
      this.$store.state.InformationOne.posts.map((item) => {
        window.scrollTo({
          top: '0',
        });
        if (v.rendered == item.title.rendered) {
          this.loading = true
          this.$router.push({
            path: "/article",
            query: {
              id: item.id,
            },
          });
          this.getDate()
        }
      });
    },
    padZero(number) {
      return number.toString().padStart(2, "0");
    },
    convertedTime(time) {
      // 将原始时间转换为用户所在时区的时间
      const utcMoment = moment.utc(time);
      const beijingMoment = utcMoment.clone().tz('Asia/Shanghai');
      return beijingMoment.format('YYYY-MM-DD HH:mm:ss');
    },
    getDate() {
      this.loading = true
      this.content = ''
      this.article = ''

      var count = 0
      let timer = setInterval(() => {
        count++
        if (count >= 50) {
          clearInterval(timer)
        }
        if (this.$store.state.class != '') {
          clearInterval(timer)
          // var lang = i18n.locale == 'zh' ? '/zh-cn' : '/en-us'
          console.log(this.$route.query.id);
          // this.$store.state.class.map(item => {
          //   item.subClassifications.map(it => {
          //     console.log(it);
          //     it.articles.map(i => {
          //       console.log(i);
          //       if (i.id == this.$route.query.id) {
          //         this.article = i
          //         console.log(i);
          //       }
          //     })
          //   })
          // })
          this.$axios({
            method: 'get',
            url: this.$backend.wpHost + '/posts' + '/' + this.$route.query.id,
          }).then(res => {
           
            const parser = new DOMParser();
            const doc = parser.parseFromString(res.data.content.rendered, "text/html");
            console.log(doc);
           
            const links = doc.querySelectorAll("a");
            links.forEach(link => {
              link.setAttribute("target", "_blank");
            });
            // 将处理后的 DOM 对象转换回 HTML 字符串

            const updatedContent = doc.documentElement.innerHTML;
            this.content = updatedContent
            this.article = res.data
            gtag('event', 'screen_view', {
              
              'article_title': this.article.title.rendered
            });
            this.loading = false
          }).catch(err => {
            console.log(err);
          })
        }
      }, 1000);
    },
    dateTrans(date) {
      // let _date = new Date(parseInt(date));//13位
      let _date = new Date(parseInt(date) * 1000);//10位
      let y = _date.getFullYear();
      let m = _date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      let d = _date.getDate();
      d = d < 10 ? ('0' + d) : d;
      let h = _date.getHours();
      h = h < 10 ? ('0' + h) : h;
      let minute = _date.getMinutes();
      let second = _date.getSeconds();
      minute = minute < 10 ? ('0' + minute) : minute; second = second < 10 ? ('0' + second) : second;
      // let dates = y + '-' + m + '-' + d;//年月日
      let dates = y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;//年月日时分秒
      return dates;
    }
  },
  created() { },
};
</script>

<style lang="scss" scoped>
.p1::v-deep {
  // 这里可以添加任何你需要的样式，例如修改链接颜色。
  line-height: 1.7;

  .has-vivid-purple-color {
    color: #9B51E0;
  }

  .has-vivid-cyan-blue-color {
    color: #0693E3;
  }

  .has-base-color {
    color: #fff;
  }

  .has-contrast-color {
    color: #000000;
  }

  .has-cyan-bluish-gray-color {
    color: #ABB8C3;
  }

  .has-pale-pink-color {
    color: #F78DA7;
  }

  .has-vivid-red-color {
    color: #CF2E2E;
  }

  .has-luminous-vivid-orange-color {
    color: #FF6900;
  }

  .has-luminous-vivid-amber-color {
    color: #FCB900;
  }

  .has-light-green-cyan-color {
    color: #7BDCB5;
  }

  .has-vivid-green-cyan-color {
    color: #00D084;
  }

  .has-pale-cyan-blue-color {
    color: #8ED1FC;
  }

  .has-tertiary-color {
    color: #F6F6F6;
  }

  .has-secondary-color {
    color: #345C00;
  }

  .has-primary-color {
    color: #9DFF20;
  }

  figure {
    margin-left: 0;
  }

  p {

    /* 设置段落下方的间距 */
    min-height: 2px;
    margin: 0 0 14px 0;
    line-height: 1.7;
  }

  ul {
    padding-left: 0px;
    margin-left: 21px;
  }

  ol {
    padding-left: 0px;
    margin-left: 21px;

    >li:not(:last-child) {
      margin-bottom: 14px;
    }
  }

  strong {
    font-family: 'MohrRounded Black', HYZhengYuan-85W, Microsoft YaHei, sans-serif;

  }

  figure {
    margin: 0;
  }

  h2 {
    font-size: 20px;
    margin: 0 0 12px 0;
    line-height: 1.8;
  }

  li {
    img {
      margin-left: -5px;
    }
  }

  img {
    max-width: 100%;
    // height: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    position: relative;
    left: 0;
    display: block;
    height: auto;
  }

  video {
    width: 100%;
  }

  a {
    color: #ffc000;
  }
}

@import "../assets/scss/article.scss";
</style>